export const SET_GLOBAL_ERROR = 'SET_GLOBAL_ERROR'
export const SET_STUDENT_USER_ID = 'SET_STUDENT_USER_ID'
export const SET_APPLICATION_NUMBER = 'SET_APPLICATION_NUMBER'
